import type { FinancialsT } from '../metricReading';

/**
 * Names for freshly created contracts.
 *
 * The FIRST contract on a project takes the project's name (2026-09-24, the
 * pilot's ask; the " - Main contract" suffix went on 2026-10-08): a project
 * with one contract has nothing to tell the contracts apart by, and the
 * project's own name reads right in the first-contract prompt ("Connect the
 * plan to Ship?") and in the task's contract picker. Every later contract keeps the
 * design's NEXT_NAMES series, "Contract A", "Contract B", …, skipping names
 * already taken, so a second contract is visibly a second one. The series
 * word is the user's language at creation ("Kontrakt A" in Danish); the name
 * is then stored like any other.
 */
export const nextContractName = (
  t: FinancialsT,
  existingNames: readonly string[],
  projectName?: string,
): string => {
  const named = (suffix: string) => t('pmFinancials:contracts.DefaultName', { suffix });
  const trimmedProject = projectName?.trim() ?? '';
  if (existingNames.length === 0 && trimmedProject !== '') {
    return trimmedProject;
  }
  const taken = new Set(existingNames.map((name) => name.trim().toLowerCase()));
  for (let i = 0; i < 26 * 2; i++) {
    const letter = String.fromCharCode(65 + (i % 26));
    const candidate = named(i < 26 ? letter : `${letter}${Math.floor(i / 26)}`);
    if (!taken.has(candidate.toLowerCase())) return candidate;
  }
  return named(String(existingNames.length + 1));
};
